import * as React from 'react';
import './SectionLabel.scss';

const SectionLabel = ({ text }) => <div className="SectionLabel">{text}</div>;

export default SectionLabel;
